import Vue from 'vue'

Vue.mixin({
    data () {
      return {
        preloader: 'data:image/svg+xml;base64,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',
        siteName: process.env.VUE_APP_SITE_NAME,
        logo: require('../assets/logo.png')
      }
    },
    computed: {
      dialogWidth () {
        return this.$vuetify.breakpoint.lgAndUp ? '60%' : (this.$vuetify.breakpoint.mdOnly ? '75%' : '90%')
      },
      isSuperAdmin () {
        if (this.$store.state.loggedIn) {
          return this.$store.state.user.is_superadmin
        } else {
          return false
        }
      },
      permittedSucursalesIDs () {
        return this.$store.state.user.sucursales.map(item => item.id)
      }
    },
    methods: {
      processError (error) {
        console.log(error)
        if (error !== undefined) {
          if (error.hasOwnProperty('status') && error.status === 401) {
            EventBus.$emit('logout')
          }

          if (error.hasOwnProperty('body')) {
            if (error.body.hasOwnProperty('message')) {
              this.errorMessage(error.body.message)
              return
            }
          }

          if (error.hasOwnProperty('message')) {
            this.errorMessage(error.message)
          }
        }

        this.errorMessage()
      },
      processSuccess (success) {
        if (success !== undefined) {
          if (success.hasOwnProperty('body')) {
            if (success.body.hasOwnProperty('message')) {
              this.successMessage(success.body.message)
              EventBus.$emit('success-done')
              return
            }
          }

          if (success.hasOwnProperty('message')) {
            this.successMessage(success.message)
            EventBus.$emit('success-done')
            return
          }
        }

        this.successMessage()
        EventBus.$emit('success-done')
        return
      },
      errorMessage (msg) {
        if (msg === undefined || msg === null) msg = this.$t('app.errors.generic')
        if (typeof msg === 'object') {
          let aux = []
          for (let key in msg) {
            aux.push(msg[key])
          }
          msg = aux.join("\n\r")
        }

        this.$swal({
          title: this.$t('app.errors.title'),
          text: msg,
          icon: 'error',
          button: this.$t('app.buttons.ok'),
        })
      },
      successMessage (msg, callback) {
        console.log(msg)
        if (msg === undefined || msg === null) msg = this.$t('app.success.message')
        if (typeof msg === 'object') {
          let aux = []
          for (let key in msg) {
            aux.push(msg[key])
          }
          msg = aux.join("\n\r")
        }

        if (callback === undefined) {
          callback = (v) => {
          }
        }

        this.$swal({
          title: this.$t('app.success.title'),
          text: msg,
          icon: 'success',
          button: this.$t('app.buttons.ok'),
        }).then(value => {
          callback(value)
        })
      },
      toggleLoader () {
        EventBus.$emit('processing')
      },
      goTo (name, params) {
        this.$router.push({
          name: name,
          params: params,
        })
      },
      tokenizeName (name) {
        let tokens = name.split(" ")
        let tokenized = ''
        if (tokens.length > 0) {
          let index = 0
          do {
            tokenized += tokens[index][0]
            index++
          } while (index < tokens.length && index < 2)
        }

        return tokenized.toUpperCase()
      },
      rgbaColor (object) {
        if (
          object != null &&
          typeof object === 'object' &&
          object.hasOwnProperty('r') &&
          object.hasOwnProperty('g') &&
          object.hasOwnProperty('b') &&
          object.hasOwnProperty('a')
        ) {
          return `rgba(${object.r}, ${object.g}, ${object.b}, ${object.a})`
        }
      },
      lightOrDark (color) {
        // Variables for red, green, blue values
        var r, g, b, hsp
        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {
          // If RGB --> store the red, green, blue values in separate variables
          color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

          r = color[1]
          g = color[2]
          b = color[3]
        } else {
          // If hex --> Convert it to RGB: http://gist.github.com/983661
          color = +("0x" + color.slice(1).replace(
            color.length < 5 && /./g, '$&$&'))

          r = color >> 16
          g = color >> 8 & 255
          b = color & 255
        }

        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        hsp = Math.sqrt(
          0.299 * (r * r) +
          0.587 * (g * g) +
          0.114 * (b * b)
        )

        // Using the HSP value, determine whether the color is light or dark
        if (hsp > 127.5) {
          return 'light'
        } else {
          return 'dark'
        }
      },
      isDarkColor (color) {
        if (color)
          return this.lightOrDark(color) == 'dark' ? true : false
      },
      isLightColor (color) {
        if (color)
          return this.lightOrDark(color) == 'light' ? true : false
      },

      getUserRoutes () {
        let permissions = []
        let controlRole = this.$store.state.user.roles.filter(role => role.name === 'superadmin')

        if (controlRole.length > 0) {
          permissions = this.$store.state.modules.map(module => module.to)
          let withChild = this.$store.state.modules.filter(module => module.children)
          let children = withChild.map(module => module.children)
          if (children.length > 0) {
            children = children[0].map(child => child.to)
            permissions = [
              ...permissions,
              ...children
            ]
          }
        } else {

          for (let role of this.$store.state.user.roles) {
            permissions = [...permissions, ...role.permissions]
          }

          if (permissions.length > 0) {
            permissions = permissions.map(permission => permission.route)
          }
        }

        return permissions
      },
      userCheck (route) {
        let permissions = this.getUserRoutes()

        if (!permissions.includes(route.name)) {
          this.$router.replace('/')
          this.errorMessage(this.$t('app.errors.unauthorized'))
          return false
        } else {
          return true
        }
      },

      prepareForExcel (data, headers, hiddenColumns) {
        if (hiddenColumns === undefined) hiddenColumns = []
        let excel = []

        for (let item of data) {
          let aux = {}

          for (let column of headers) {
            let value = item[column.value]

            if (!hiddenColumns.includes(column.value)) {
              if (column.value.includes('.')) {
                value = item
                let parts = column.value.split('.')

                for (let part of parts) {
                  if (value.hasOwnProperty(part)) {
                    value = value[part]
                  } else {
                    if (Array.isArray(value)) {
                      value = value.map(item => item[part])
                    }
                  }
                }
              }

              if (typeof value != 'string' && typeof value != 'boolean' && value != undefined && typeof value.join === 'function') {
                value = value.join(', ')
              }

              aux[column.text] = value
            }
          }

          excel.push(aux)
        }

        return excel
      },

      //==================================================

      async getRoles (token) {
        let roles = []

        await this.$http.get(route('v1/role'), {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        })
          .then(response => {
            if (response.body.code === 200) {
              roles = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return roles
      },
      async getRolesProtected (token) {
        let roles = []

        await this.$http.get(route('v1/role/protected'), {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        })
          .then(response => {
            if (response.body.code === 200) {
              roles = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return roles
      },
      async getStates () {
        let estados = []

        await this.$http.get(route('v1/state'))
          .then(response => {
            if (response.body.code === 200) {
              estados = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return estados
      },
      async getMunicipalityByEstado (estadoID) {
        let municipios = []

        await this.$http.get(route('v1/municipality/by-state/' + estadoID))
          .then(response => {
            if (response.body.code === 200) {
              municipios = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return municipios
      },
      async getLocationsByMunicipality (municipalityID) {
        let localidades = []

        await this.$http.get(route('v1/location/by-municipality/' + municipalityID))
          .then(response => {
            if (response.body.code === 200) {
              localidades = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return localidades
      },
      async getBranches () {
        let sucursales = []

        await this.$http.get(route('v1/branch'))
          .then(response => {
            if (response.body.code === 200) {
              sucursales = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        if (this.isSuperAdmin || !this.$store.state.loggedIn)
          return sucursales
        else
          return sucursales.filter(item => this.permittedSucursalesIDs.includes(item.id))
      },
      async getMunicipality (municipalityID) {
        let municipality = false

        await this.$http.get(route('v1/municipality/' + municipalityID))
          .then(response => {
            if (response.body.code === 200) {
              municipality = response.body.data[0]
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return municipality
      },
      async getLocation (locationID) {
        let location = false

        await this.$http.get(route('v1/location/' + locationID))
          .then(response => {
            if (response.body.code === 200) {
              location = response.body.data[0]
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return location
      },
      async getUsuarios () {
        let usuarios = []

        await this.$http.get(route('v1/user'))
          .then(response => {
            if (response.body.code === 200) {
              usuarios = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return usuarios
      },
      async getEquipos () {
        let equipos = []
        await this.$http.get(route('v1/team'))
          .then(response => {
            if (response.body.code === 200) {
              equipos = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return equipos
      },
      async getTorneos () {
        let torneos = []

        await this.$http.get(route('v1/tournament'))
          .then(response => {
            if (response.body.code === 200) {
              torneos = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return torneos
      },
      async getTorneosSearch (query) {
        let torneos = []

        await this.$http.post(route('v1/tournament/search'), query)
          .then(response => {
            if (response.body.code === 200) {
              torneos = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return torneos
      },
      async getCanchas () {
        let canchas = []

        await this.$http.get(route('v1/field'))
          .then(response => {
            if (response.body.code === 200) {
              canchas = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return canchas
      },
      async getCanchasSearch (query) {
        let canchas = []

        await this.$http.post(route('v1/field/search'), query)
          .then(response => {
            if (response.body.code === 200) {
              canchas = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return canchas
      },
      async getJuegosInformales () {
        let juegosInformales = []

        await this.$http.get(route('v1/informal-play'))
          .then(response => {
            if (response.body.code === 200) {
              juegosInformales = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return juegosInformales
      },
      async getArbitros () {
        let arbitros = []

        await this.$http.get(route('v1/referee'))
          .then(response => {
            if (response.body.code === 200) {
              arbitros = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return arbitros
      },
      async getPosiciones () {
        let posiciones = []

        await this.$http.get(route('v1/position'))
          .then(response => {
            if (response.body.code === 200) {
              posiciones = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return posiciones
      },
      async getJugadores () {
        let jugadores = []

        await this.$http.get(route('v1/player'))
          .then(response => {
            if (response.body.code === 200) {
              jugadores = response.body.data
            } else {
              this.processError(response)
            }
          }, error => {
            this.processError(error)
          })

        return jugadores
      },
      async getEventos () {
        let eventos = []

        await this.$http.get(route('v1/event'))
          .then(response => {
            if (response.body.code === 200) {
              eventos = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return eventos
      },
      async getTipoIdentificacion () {
        let items = []

        await this.$http.get(route('v1/id-type'))
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async getDeportes () {
        let items = []

        await this.$http.get(route('v1/sport'))
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async getCostoHorarios () {
        let items = []

        await this.$http.get(route('v1/rate'))
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async getDivisas () {
        let items = []

        await this.$http.get(route('v1/currency'))
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async getConversionDivisas () {
        let items = []

        await this.$http.get(route('v1/currency-conversion'))
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async getTipoConceptoPago () {
        let items = []

        await this.$http.get(route('v1/payment-concept-type'))
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async getConceptoPago () {
        let items = []

        await this.$http.get(route('v1/payment-concept'))
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async getDivisaBase (token) {
        let item = false

        await this.$http.get(route('v1/base-currency'), {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        })
          .then(response => {
            if (response.body.code === 200) {
              let items = response.body.data
              if (items.length > 0) {
                item = items[0]
              } else {
                this.processError()
              }
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return item
      },
      currencyConverter (value, factor, operation, decimals = 2) {
        const operations = {
          '*': (value, factor) => (value * factor),
          '/': (value, factor) => (value / factor),
        }

        return operations[operation] (value, factor) .toFixed(decimals)
      },
      async getFormasPago (token = false) {
        let items = []

        let headers = {}

        if (token) {
          headers['Authorization'] = 'Bearer' + token
        }

        await this.$http.get(route('v1/payment-method'), {
          headers: headers,
        })
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async getRentasConfig () {
        let items = []

        await this.$http.get(route('v1/rent-config'))
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(this.errorMessage()))

        return items
      },
      async findPlayer (query) {
        let items = []

        await this.$http.post(route('v1/player/search'), {
          search: query,
        })
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
      async findPlayerWithoutCredential (query) {
        let items = []

        await this.$http.post(route('v1/player/search'), {
          search: query,
          credential: false,
        })
          .then(response => {
            if (response.body.code === 200) {
              items = response.body.data
            } else {
              this.processError(response)
            }
          }, error => this.processError(error))

        return items
      },
    },
  },
)
